import {tns} from "tiny-slider"

class TnsSlider {
    constructor() {

        this.uspsSliderInline = null
        this.objUspsInline = { container: ".the-slider-usps__slider_inline" }
        this.hasUspsSliderInline = document.querySelector(this.objUspsInline.container)!=null
        if (this.hasUspsSliderInline) {
            this.manageUspsSliderInline(this, this.objUspsInline)
            this.resizeUspsInlineListener();
        }

        this.uspsSlider = null
        this.objUsps = { container: ".the-slider-usps__slider" }
        this.hasUspsSlider = document.querySelector(this.objUsps.container)!=null
        if (this.hasUspsSlider) {
            this.manageUspsSlider(this, this.objUsps)
            this.resizeUspsListener();
        }


        this.members = "members";
        this.services = "services";
        this.methodes = "methodes";

        this.objMethode = { container: ".method-slider" }
        this.objServices = { container: ".services__slider" }
        this.objMembers = { container: ".c_members__slider" }

        this.hasMethodeSlider = document.querySelector(this.objMethode.container)!=null
        this.hasServicesSlider = document.querySelector(this.objServices.container)!=null
        this.hasMemberSlider = document.querySelector(this.objMembers.container)!=null

        this.methodeSlider = null
        this.servicesSlider = null
        this.memberSlider = null


        if (this.hasMethodeSlider) {
            this.listMethodes()
        }
        if (this.hasServicesSlider) {
            this.listServices()
        }
        if (this.hasMemberSlider) {
            this.listMembers()
        }

        // heb ik 1 van de slider op de page!
        if (this.hasMethodeSlider || this.hasServicesSlider || this.hasMemberSlider) {
           this.resizeListener()
        }
    }

    manageUspsSliderInline (that, objItem){
        let element = document.querySelector(objItem.container)
        let amount = element.dataset.amount
        if (that.manageWindowUspsWidth(element,amount)){
            if (that.uspsSliderInline === null){
                    //debugger
                let s = {
                    "container": objItem.container,
                    "items": 1,
                    "slideBy": 1,
                    "loop": true,
                    "autoplay": true,
                    "autoplayHoverPause": false,
                    "autoplayTimeout": 3500,
                    "speed": 400,
                    "rewind": false,
                    "controls": true,
                    "controlsText": ["<", ">"],
                    "preventActionWhenRunning": true,
                    "mouseDrag": false,

                    "animateDelay": 10,
                    "autoplayResetOnVisibility": false,
                    "autoplayButton": false,
                    "autoplayButtonOutput": false,
                    "preventScrollOnTouch": false,
                    "nav": false,
                    "edgePadding": 0,
                    "gutter": 0
                }
                console.log ("Made usps slider InlineInlineInlineInlineInline")
                that.uspsSliderInline = tns(s)
                element.dataset.slider = true;
            }
        } else {
            if (that.uspsSliderInline != null) {
                console.log ("destroy usps slider InlineInlineInline")
                that.uspsSliderInline.destroy()
                that.uspsSliderInline = null
                element.dataset.slider = false;
            }
        }
    }



    manageUspsSlider (that, objItem){
        let element = document.querySelector(objItem.container)
        let amount = element.dataset.amount
        if (that.manageWindowUspsWidth(element,amount)){
            if (that.uspsSlider === null){
                    //debugger
                let s = {
                    "container": objItem.container,
                    "items": 1,
                    "slideBy": 1,
                    "loop": true,
                    "autoplay": true,
                    "autoplayHoverPause": false,
                    "autoplayTimeout": 3500,
                    "speed": 400,
                    "rewind": false,
                    "controls": true,
                    "controlsText": ["<", ">"],
                    "preventActionWhenRunning": true,
                    "mouseDrag": false,

                    "animateDelay": 10,
                    "autoplayResetOnVisibility": false,
                    "autoplayButton": false,
                    "autoplayButtonOutput": false,
                    "preventScrollOnTouch": false,
                    "nav": false,
                    "edgePadding": 0,
                    "gutter": 0
                }
                console.log ("Made usps slider")
                that.uspsSlider = tns(s)
                element.dataset.slider = true;
            }
        } else {
            if (that.uspsSlider != null) {
                console.log ("destroy usps slider")
                that.uspsSlider.destroy()
                that.uspsSlider = null
                element.dataset.slider = false;
            }
        }
    }
    resizeUspsInlineListener(event){
        let that = this
        window.addEventListener("resize", () => {
            if (that.hasUspsSliderInline) {
                that.manageUspsSliderInline(that,that.objUspsInline)
            }
        }, true);
    }
    resizeUspsListener(event){
        let that = this
        window.addEventListener("resize", () => {
            if (that.hasUspsSlider) {
                that.manageUspsSlider(that,that.objUsps)
            }
        }, true);
    }
    manageWindowUspsWidth (element, amount) {
        let intViewportWidth = window.innerWidth;
        if ( intViewportWidth < 1152 ){ return true}
        return false;
    }


    resizeListener(event){
        //console.log (" resize nee ");

        let that = this
        // refreshSliderManager
        window.addEventListener("resize", () => {
            if (that.hasMemberSlider){
                that.manageSlider(that,that.members,that.objMembers)
            }
            if (that.hasServicesSlider) {
                that.manageSlider(that,that.services,that.objServices)
            }
            if (that.hasMethodeSlider) {
                that.manageSlider(that,that.methodes,that.objMethode)
            }
            if (this.hasUspsSlider) {
                that.manageUspsSlider(that,that.objUsps)
            }

        }, true);
    }


    defaultSetting(obj){
        let y = {
            "container": obj.container,
            "items": 1.1,
            "slideBy": 1,
            "speed": 400,
            "controls": true,
            "preventActionWhenRunning": true,
            "preventScrollOnTouch": false,
            "mouseDrag": true,
            "nav": false,
            "loop": false,
            "lazyload": true,
            //"center": true,
            "edgePadding": 16,
            "gutter": 8,
            "responsive": {
                "441": {
                    "fixedWidth": 271,
                },
                "768": {
                    "fixedWidth": 271,
                },
                "1024": {
                    "fixedWidth": 309,
                    "gutter": 16
                },
                "1152": {
                    "fixedWidth": 260,
                },
                "1440": {
                    "fixedWidth": 328,
                    "gutter": 20
                }
            }
        };
        return y;
    }

    membersSetting(obj){
        let y = {
            "container": obj.container,
            "items": 1.1,
            "slideBy": 1,
            "speed": 400,
            "controls": true,
            "preventActionWhenRunning": true,
            "preventScrollOnTouch": false,
            "mouseDrag": true,
            "nav": false,
            "loop": false,
            "lazyload": true,
            "edgePadding": 16,
            "gutter": 16,
            "fixedWidth": 250,
            "responsive": {
                "441": {
                    "fixedWidth": 250,
                },
                "768": {
                    "fixedWidth": 250,
                }


            }
        };
        return y;
    }


    listMethodes() {
        let that = this
        this.manageSlider(that,that.methodes,that.objMethode)
    }
    listMembers() {
        let that = this
        this.manageSlider(that,that.members,that.objMembers)
    }
    listServices() {
        let that = this
        this.manageSlider(that,that.services,that.objServices)
    }

    manageSlider(that,key, objItem){

        let element = document.querySelector(objItem.container);
        let amount = element.dataset.amount;
        let neededSlider = that.manageWindowWidth(element,amount);

        if (key === that.members){
            if (neededSlider){
                if (that.memberSlider == null){
                    let s = that.membersSetting(objItem);
                    that.memberSlider = tns(s)
                    element.dataset.slider = true;
                }
            } else {
                if (that.memberSlider != null) {
                    that.memberSlider.destroy()
                    that.memberSlider = null
                    element.dataset.slider = false;
                }
            }

        }
        if (key === that.services){
            if (neededSlider){
                if (that.servicesSlider == null){
                    let s = that.defaultSetting(objItem);
                    that.servicesSlider = tns(s)
                    element.dataset.slider = true;
                }
            } else {
                if (that.servicesSlider != null) {
                    that.servicesSlider.destroy()
                    that.servicesSlider = null
                    element.dataset.slider = false;
                }
            }

        }

        if (key === that.methodes){
            if (neededSlider){
                if (that.methodeSlider == null){
                    let s = {
                        "container": objItem.container,
                        "items": 1,
                        "slideBy": 1,
                        "speed": 400,
                        "controls": false,
                        "preventActionWhenRunning": true,
                        "preventScrollOnTouch": false,
                        "mouseDrag": true,
                        "nav": true,
                        "navPosition": "bottom",
                        "loop": false,
                        "lazyload": true,
                        "edgePadding": 0,
                        "gutter": 8,
                        responsive: {
                            768: {
                                // enable slider on big viewport
                                disable: true,
                                item: 4
                            }
                        }
                    }
                    that.methodeSlider = tns(s)
                    element.dataset.slider = true;
                }
            } else {
                if (that.methodeSlider != null) {
                    that.methodeSlider.destroy()
                    that.methodeSlider = null
                    element.dataset.slider = false;
                }
            }

        }
    }


    manageWindowWidth (element, amount) {
        // return
        // false no slider / destroy
        // true need slider amount

        // 1 niks, 2 441, 3 768 4 1024, 5 en meer - 1152 / 1440
        let intViewportWidth = window.innerWidth;
        if ( amount <= 1 ){  return false;} /* 1.2*/
        if ( amount >= 5 ){  return true;} /* 5 of meer */
        if ( intViewportWidth < 441  && amount > 1 ){ return true} /* 1.2*/
        if ( intViewportWidth < 768  && amount > 2 ){  return true} /* 2.5*/
        if ( intViewportWidth < 1024 && amount > 3 ){ return true}  /* 3.2*/
        if ( intViewportWidth < 1152 && amount > 4 ){  return true}  /* 4*/
        if ( intViewportWidth < 1440 && amount > 4 ){ return true} /* 4.1*/
        if ( intViewportWidth < 1920 && amount > 5 ){ return true} /* 5*/

        return false;
    }


}

export default TnsSlider